module.exports = require("prismjs/components/prism-objectivec.js");